<div class="w-full" [id]="layoutData.uuid">
  <app-dropdown [label]="'Content Type'" [options]="contentTypeOptions"
                [parentFormGroup]="layoutForm" class="content-type-select" controlName="contentType"
                placeholder="Select Content Type" type=" small"/>
</div>
